import { Button, ButtonProps } from "primereact/button";
import React from "react";
import styled from "styled-components";
import { concatClassnames } from "../../utils/util";

export interface CvpButtonProps extends ButtonProps {
  label?: string;
}

export const CvpButton = (props: CvpButtonProps) => {
  const { label, className, style, size, ...otherProps } = props;

  const buttonSize = size ? size : "small";
  return (
    <StyledCvpButton
      iconPos="right"
      size={buttonSize}
      label={label}
      style={style}
      className={concatClassnames(["cvp-button", className])}
      {...otherProps}
    />
  );
};

const StyledCvpButton = styled(Button)`
  &.cvp-button {
    padding: 0.7rem 1rem;
    display: flex;
    align-items: center;

    .p-button-label {
      font-weight: 600;
      font-size: 0.95em;
    }

    .p-button-icon {
      font-size: 0.95em;
    }
    &.p-button:focus {
      box-shadow: 0 0 0 0.1rem var(--primary-200);
    }

    &.active-btn {
      background: var(--primary-500);
      color: white;
      border: 1px solid var(--primary-500);
    }
  }
`;
